import classes from "../../styles/NewArticle.module.scss"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import ArticleForm from "../../components/Knowladge/ArticleForm"
import { createArticle } from "../../utils/requests/knowladgebase"

const NewArticle = () => {
  const [loading, setLoading] = useState(false)

  const [article, setArticle] = useState<Partial<KnowladgebaseArticle>>({})
  const navigate = useNavigate()

  const onSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    const { id, success } = await createArticle(article)

    setLoading(false)

    if (!success) {
      return
    }
    if (id) {
      navigate(`/article/edit/${id}`)
    } else {
      navigate(-1)
    }
  }

  return (
    <div className={classes.root}>
      <ArticleForm
        formTitle="מאמר חדש"
        values={article}
        onSubmit={onSubmit}
        onChange={setArticle}
        loading={loading}
        ctaLabel="יצירת מאמר"
      />
    </div>
  )
}

export default NewArticle
